import React from "react";
import { Link } from "react-router-dom";
import { AlertCircle, Lock } from "lucide-react";

import { useCustomerAuth } from "@/context/CustomerAuthContext";
import { useOdoo } from "@/context/OdooContext";
import { useLanguage } from "@/context/LanguageContext";

export default function FinancialGate({ children, t }) {
  const { customer } = useCustomerAuth();
  const { linked, loading, linkError, refreshClient } = useOdoo();
  const { lang } = useLanguage();
  const align = lang === "ar" ? "text-right" : "text-left";

  if (loading) {
    return (
      <div className="flex justify-center py-16">
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-[#F37021]/20 border-t-[#F37021]" />
      </div>
    );
  }

  if (!customer) {
    return (
      <div className={`mx-auto max-w-lg rounded-[28px] border border-black/8 bg-white p-8 text-center shadow-sm dark:border-white/10 dark:bg-[#121212] ${align}`}>
        <Lock className="mx-auto h-8 w-8 text-[#8FA1B8]" />
        <h2 className="mt-4 text-lg font-bold text-[#0a1628] dark:text-white">{t.gate_signin_title}</h2>
        <p className="mt-2 text-sm leading-6 text-[#667083] dark:text-[#BAC4D4]">{t.gate_signin_text}</p>
        <Link
          to="/login"
          className="mt-6 inline-flex h-11 items-center justify-center rounded-full bg-[#F37021] px-6 text-sm font-semibold text-white hover:bg-[#d85f15]"
        >
          {t.gate_signin_btn}
        </Link>
      </div>
    );
  }

  if (!linked) {
    return (
      <div className={`mx-auto max-w-lg rounded-[28px] border border-black/8 bg-white p-8 text-center shadow-sm dark:border-white/10 dark:bg-[#121212] ${align}`}>
        <AlertCircle className="mx-auto h-8 w-8 text-[#8FA1B8]" />
        <h2 className="mt-4 text-lg font-bold text-[#0a1628] dark:text-white">
          {t.gate_no_match_title || "Customer Portal unavailable"}
        </h2>
        <p className="mt-2 text-sm leading-6 text-[#667083] dark:text-[#BAC4D4]">
          {t.gate_no_match_text ||
            "We could not load your BOB Services LB Customer Portal right now. Please try again in a moment."}
        </p>
        {linkError ? (
          <p className="mt-3 text-sm text-[#F37021]">{linkError}</p>
        ) : null}
        <button
          type="button"
          onClick={() => refreshClient()}
          className="mt-6 inline-flex h-11 items-center justify-center rounded-full bg-[#F37021] px-6 text-sm font-semibold text-white hover:bg-[#d85f15]"
        >
          {t.gate_retry_btn || "Try again"}
        </button>
      </div>
    );
  }

  return children;
}
